import { DotIcon } from "lucide-react"

import { StatusOption } from "../../types"

export const STATUS_OPTIONS: StatusOption[] = [
  {
    id: "active",
    name: "Active",
    icon: <DotIcon size={8} color="#22c55e" strokeWidth={16} />,
    tooltipText:
      "Enrolled in rate alert emails. The rate dashboard is accessible."
  },
  {
    id: "disable",
    name: "Disable",
    icon: <DotIcon size={8} color="#eab308" strokeWidth={16} />,
    tooltipText:
      "Unsubscribed from rate alert emails. The rate dashboard remains accessible."
  },
  {
    id: "delete",
    name: "Delete",
    icon: <DotIcon size={8} color="#dc2626" strokeWidth={16} />,
    tooltipText:
      "The rate dashboard is inaccessible. Unsubscribed from rate alert emails."
  }
]
